export default __webpack_public_path__ + "static/Ammonite_Bile-c073c24b8b5f20215e2d71be9461c81b.png";